import Headline from "./atoms/headline"
import { PhoneIcon, MailIcon } from "./atoms/contactIcons"

const Contact = () => {
    return (
        <div id='contact' className='section'>
            <Headline
                title={'Contact'}
                subTitle={'お問い合わせ'}
            />
            <div className="contact-actions">
                <a className='action-button primary' href='tel:0493-81-6300'>
                    <PhoneIcon />
                    0493-81-6300
                </a>
                <a className='action-button secondary' href='mailto:liina.dancestudio@gmail.com'>
                    <MailIcon />
                    liina.dancestudio@gmail.com
                </a>
            </div>
        </div>
    )
}

export default Contact
